<template lang="html">
  <div id="subprojectpage" >
    <section class="container oversized-container">
      <div class="row">
        <div class="col-md-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">{{ $t("shared.titles.home") }}</router-link></li>
              <li class="breadcrumb-item"><router-link to="/proyectos">{{ $t("shared.titles.projects") }}</router-link></li>
              <li class="breadcrumb-item active" aria-current="page" >{{ $t("shared.titles.list") }}</li>
            </ol>
          </nav>
        </div>
      </div>

      <div class="row" >
        <div v-for="project in projects" class="col-md-6 col-xl-4 col-subproject">
          <router-link class="project-link" :to="'/detalle/proyecto/'+project.id">
            <img class="placed-backg img-fluid" src="public/images/shared/article.png" v-bind:style="{ backgroundImage: 'url('+project.image+')' }">

            <div class="box">
              <div class="inside">
                <h5>{{ project.name }}</h5>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      projects:[
       /* { id: 1, image: 'public/images/pages/projects/project-7.jpg', name: 'Torre de Departamentos en Vista Hermosa Cuernavaca', },
        { id: 2, image: 'public/images/pages/projects/project-6.jpg', name: 'Clinica de Hemodiálisis en Poza Rica Veracruz', },
        { id: 3, image: 'public/images/pages/projects/project-5.jpg', name: 'Torre Ankara en Plan de San Luis Guadalajara', },
        { id: 3, image: 'public/images/pages/projects/project-4.jpg', name: 'Torre de Departamentos en Polanco Ciudad de México', },
        { id: 1, image: 'public/images/pages/projects/project-3.jpg', name: 'Torre de Departamentos en Av. Guadalupe Jardines de Guadalupe Guadalajara', },
        { id: 2, image: 'public/images/pages/projects/project-2.jpg', name: 'Torre en Plan de San Luis Zapopan Jalisco', },*/
      ],
    }
  },

  methods: {
    flaggedProject() {
      var flagProject = "hotel";
      console.log(flagProject)
    },

    getProjects:function(id){
      axios.get(tools.url('/projectsFront/'+this.id)).then(
        ({data}) =>{
          this.projects=data;
        }
      );
    },
  },

  mounted() {
     this.id = this.$route.params.id;
    this.getProjects(this.id);
    this.flaggedProject();
  },
}
</script>
